import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Home from "../Components/Home";
import Navr from "../Navbar/Navr";
import Main from "../Components2/Main";
// import Footer from "../Components2/Footer";
import Domestic from "../Components2/Domestic";
import ClientReviews from "../Components2/ClientReviews";
import Nav2 from "../Navbar/Nav2";
import About from "../Components2/About";
import Services from "../Components2/Services";
import Packages from "../Components2/Packages";
import Contact from "../Components2/Contact";
import Rajasthan from "../Compo/Rajasthan";
import Himachal from "../Compo/Himachal";
import Kerala from "../Compo/Kerala";
import Kashmir from "../Compo/Kashmir";
import Summer from "../Components2/Summer";
import Privacy from "../Components2/Privacy";
import Terms from "../Components2/Terms";
import { FaWhatsapp } from "react-icons/fa";
export default function Router() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Nav2 />}>
            <Route index element={<Main />} />

          
            <Route path="/Navr" element={<Navr />} />
            <Route path="/Domestic" element={<Domestic />} />
            <Route path="/ClientReviews" element={<ClientReviews />} />
            <Route path="/About" element={<About />} />
            <Route path="/Services" element={<Services />} />
            <Route path="/Packages" element={<Packages />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/Rajasthan" element={<Rajasthan />} />
            <Route path="/Himachal" element={<Himachal />} />
            <Route path="/Kerala" element={<Kerala />} />
            <Route path="/Kashmir" element={<Kashmir />} />
            <Route path="/Summer" element={<Summer />} />
            <Route path="/Privacy" element={<Privacy />} />
            <Route path="/Terms" element={<Terms />} />
            


          </Route>
        </Routes>
      </BrowserRouter>
      <a 
      href="https://wa.me/919828074121" // Niche instructions dekhein
      className="whatsapp_float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp />
    </a>
    </>
  );
}
